import { LOGIN } from "../lib/constants/actions";


export const tryLogin = (data) => {
    return {
        type: LOGIN.TRY_LOGIN,
        payload: data
    }
}
export const loginSuccess = (data) => {
    return {
        type: LOGIN.LOGIN_SUCCESS,
        payload: data
    }
}


export const getLoginData = (data) => {
    return {
        type: LOGIN.GET_LOGIN_DATA,
        payload: data
    }
}
export const getLoginDataSuccess = (data) => {
    return {
        type: LOGIN.GET_LOGIN_DATA_SUCCESS,
        payload: data
    }
}


export const changePassword = (data) => {
    return {
        type: LOGIN.CHANGE_PASSWORD,
        payload: data
    }
}
export const changePasswordSuccess = (data) => {
    return {
        type: LOGIN.CHANGE_PASSWORD_SUCCESS,
        payload: data
    }
}

export const resetPassword = (data) => {
    return { type: LOGIN.RESET_PASSWORD, payload: data}
}
export const resetPasswordSuccess = (data) => {
    return { type: LOGIN.RESET_PASSWORD_SUCCESS, payload: data}
}

export const verifyOtp = (data) => { return { type: LOGIN.VERIFY_OTP, payload: data }}
export const verifyOtpSuccess = (data) => { return { type: LOGIN.VERIFY_OTP_SUCCESS, payload: data }}

